import { render } from "./CameraSourceFilter.vue?vue&type=template&id=039a4512&scoped=true"
import script from "./CameraSourceFilter.vue?vue&type=script&lang=js"
export * from "./CameraSourceFilter.vue?vue&type=script&lang=js"

import "./CameraSourceFilter.vue?vue&type=style&index=0&id=039a4512&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039a4512"]])

export default __exports__